// This gives named constants to the Aircraft data properties.
const AircraftProperty = {
	STATE: "event",
	FLIGHT_NUMBER: "flight",
	FLIGHT_OPERATOR: "operator",
	EQUIPMENT: "equipment",
	REGISTRATION: "registration",
	ALTITUDE: "altitude",
	ALTITUDE_BARO: "altitudeBaro",
	CALL_SIGN: "callSign",
	DESTINATION_IATA: "destinationIATA",
	DESTINATION_ICAO: "destinationIACO",
	ORIGIN_IATA: "originIATA",
	ORIGIN_ICAO: "originIACO",
	TIMESTAMP: "timestamp",

	COURSE: "course",

	ICAO_ADDRESS: "icaoAddress",
	SIL: "sil",
	NAC_P: "nacp"
};
export default AircraftProperty;
